import React from 'react'
import { connect } from 'react-redux'
import { setMapReference } from '../../action/map-reference-actions'
import RenderLayers from './render-layers'
import TimeLayerBar from './time-layer-bar'
import ImageryYear from './imagery-year'
import RenderMarkers from './render-markers'
import RenderPhotos from './render-photos'
import RenderLines from './render-lines'
import RenderTracks from './render-tracks'
import RenderRoutes from './render-routes'
import RenderPolygons from './render-polygons'
import RenderCircles from './render-circles'
import featureData from '../../lib/api/featureData'
import { fetchFeatureInfoFields } from '../../action/feature-field-actions'
import isNil from 'lodash/isNil'
import MapPopup from './map-popup'
import RenderFriends from './render-friends'
import LayerToggle from './layer-toggle'
import './index.scss'
import Weather from '../map/weather/index'
import Geolocation from '../map/geoLocation/index'
import ShareMarker from '../main-ui/left-toolbar/common/share-location'
import Google3DMap from '../threedmap/threedemap'
import Loader from '../hunt-planner/reusableComponents/loader/Loader'
import { selectedTabAction } from '../../action/selected-tab-action'
import { selected3dMapAction, unselected3dMapAction } from '../../action/selected-3dmap'
import { userHasPro } from '../../lib/util'
import { showHideSubscriptionModal } from '../../utils/subscriptionUtils'
import WelcomePage from '../threedmap/welcomePage'
import RenderGearDropMarkers from './render-gear-drop-markers'
import CheckWind from '../check-wind'
import { markStartView } from '../../lib/artemis/context'

class Map extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      map: null,
      featureData: null,
      loadspinner: false,
      openThreeD: false,
      load3dMap: false,
      welcomePage: true
    }
    this.getZoomButtons = this.getZoomButtons.bind(this)
    this.doubleClicked = false
    this.mapContainer = React.createRef();
  }



  getZoomButtons() {
    const zoomContainer = document.createElement('div');
    const zoomOut = document.createElement('div');
    const zoomIn = document.createElement('div');
    const zoomInIcon = document.createElement('div');
    const zoomOutIcon = document.createElement('div');

    zoomContainer.className = 'map-zoom-container'; // Add a class for the container
    zoomIn.className = 'map-zoom-in';
    zoomOut.className = 'map-zoom-out';
    zoomOutIcon.className = 'map-zoom-out-icon';
    zoomInIcon.className = 'map-zoom-in-icon';

    zoomOut.appendChild(zoomOutIcon);
    zoomIn.appendChild(zoomInIcon);
    zoomContainer.appendChild(zoomOut); // Append zoomOut to the container
    zoomContainer.appendChild(zoomIn); // Append zoomIn to the container


    zoomIn.addEventListener('click', e => {
      e.stopPropagation();
      const zoom = this.state.map.getZoom();
      this.state.map.setZoom(zoom + 1);
    });

    zoomOut.addEventListener('click', e => {
      e.stopPropagation();
      const zoom = this.state.map.getZoom();
      this.state.map.setZoom(zoom - 1);
    });

    return zoomContainer; // Return the container instead of an array
  }
  componentDidMount() {
    this.setState(
      {
        map: new google.maps.Map(this.mapContainer.current, {
          zoom: 4,
          center: new google.maps.LatLng({ lat: 39.71, lng: -100.21 }),
          fullscreenControl: false,
          clickableIcons: false,
          zoomControl: false,
          scaleControl: true,
          rotateControl: false,
          mapTypeControl: false,
          gestureHandling: 'greedy',
          minZoom: 3,
          mapId: "4504f8b37365c3d0",
          rotateControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          options: {
            styles: [
              {
                featureType: 'all',
                elementType: 'labels',
                stylers: [{ visibility: 'on' }]
              }
            ]
          },
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          restriction: {
            latLngBounds: {
              north: 85,
              south: -85,
              west: -180,
              east: 180
            },
            strictBounds: false
          }
        })
      }, () => {
        // Test seam: expose the Google Maps instance for e2e/smoke tests.
        // Stripped from production builds by the __DEBUG__ flag.
        if (__DEBUG__) {
          window.__bm = window.__bm || {}
          window.__bm.map = this.state.map
        }
        // Until the user's place is shown, Artemis isn't told this starting view as theirs (WEB-7172).
        markStartView(this.state.map, { lat: 39.71, lng: -100.21, zoom: 4 })
        this.props.setMapReference(this.mapReference.bind(this))
        setTimeout(() => {
          this.handleUnitPreferenceChange();
        }, 3000);
        const zoomControlsContainer = this.getZoomButtons();
        this.state.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlsContainer);
        this.state.map.addListener('dblclick', () => {
          this.doubleClicked = true
        })
        this.state.map.addListener('click', (e) => {

          const y = e.pixel.y;
          const x = e.pixel.x;

          const mapDivRect = this.state.map.getDiv()

          // Get the height and width of the map container
          const mapHeight = mapDivRect.offsetHeight;
          const mapWidth = mapDivRect.offsetWidth;

          // Define thresholds for the corners (adjust as needed)
          const topThreshold = mapHeight / 3;   // Top third of the map
          const bottomThreshold = mapHeight * 2 / 3;  // Bottom third of the map
          const leftThreshold = mapWidth / 3;   // Left third of the map
          const rightThreshold = mapWidth * 2 / 3;  // Right third of the map

          // console.log(topThreshold, bottomThreshold, y);

          let transformStyle = {};

          if (y < topThreshold) {
            // Top half of the map
            if (x < leftThreshold) {
              // Top-left corner
              console.log('Click is in the top-left corner.');
              transformStyle = { transform: `translate(0%, 0%)` }; // Show modal to the right
            } else if (x > rightThreshold) {
              // Top-right corner
              console.log('Click is in the top-right corner.');
              transformStyle = { transform: `translate(-100%, 0%)` }; // Show modal to the left
            } else {
              // Middle of the top third
              console.log('Click is in the middle top.');
              transformStyle = { transform: `translate(0%, 0%)` }; // Modal above the click position
            }
          } else {
            // Bottom half of the map
            if (x < leftThreshold) {
              // Bottom-left corner
              console.log('Click is in the bottom-left corner.');
              transformStyle = { transform: `translate(-2%, -99%)` }; // Show modal to the right
            } else if (x > rightThreshold) {
              // Bottom-right corner
              console.log('Click is in the bottom-right corner.');
              transformStyle = { transform: `translate(-96%, -100%)` }; // Show modal to the left
            } else {
              // Middle of the bottom third
              console.log('Click is in the middle bottom.');
              transformStyle = { transform: `translate(-2%, -99%)` }; // Modal below the click position
            }
          }

          if (this.props.featuresBlocked) {
            return
          }
          this.doubleClicked = false
          if (this.state.map.overlayMapTypes.length > 0 && this.state.featureData === null) {
            this.setState({ loadspinner: true })
            const { layersDictionary, token, fetchFeatureInfoFields, featureFields } = this.props,
              zoom = this.state.map.getZoom(),
              overlayLayers = []
                .concat(this.state.map.overlayMapTypes.getArray())
                .filter(l => l?.alt?.drawOrder != null)
                .sort((a, b) => b.alt.drawOrder - a.alt.drawOrder),

              layerIds = overlayLayers.map(layer => {
                const layerData = layersDictionary[layer.alt.id]
                if (isNil(featureFields[layerData.id])) {
                  fetchFeatureInfoFields(layerData.id)
                }
                return layerData.id
              })

            // One response entry per layer id, so de-duplicate while keeping drawOrder.
            const uniqueLayerIds = [...new Set(layerIds)]

            featureData.get({
              latitude: e.latLng.lat(),
              longitude: e.latLng.lng(),
              zoomLevel: zoom,
              returnGeometry: false,
              layerIds: uniqueLayerIds
            }, token)
              .then(res => {
                this.setState({ loadspinner: false })
                if (this.doubleClicked) {
                  return
                }
                const features = []
                res.forEach(raw => {
                  raw.features.forEach(fData => {
                    fData.layerInfo = layersDictionary[raw.layer.LayerId]
                    features.push(fData)
                  })
                })
                if (features.length > 0) {
                  this.setState({
                    featureData: {
                      position: e.latLng,
                      features,
                      type: 'feature',
                      loadspinner: false,
                      transformStyle: transformStyle
                    }
                  }, () => {
                    google.maps.event.addListenerOnce(this.state.map, 'click', () => {
                      this.clearFeatureData()
                    })
                  })
                } else { }
              })
              .catch(err => {
                console.log('Feature Data Get Failed Map Click', err)
              })
          }
        })
      })

    const topValue = this.props.selectedTab == "map" ? '-70px' : "0"
    // Create or update the style element
    let styleElement = document.getElementById('gm-style');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'gm-style';
      document.head.appendChild(styleElement);
    }

    // Set the CSS rules dynamically
    styleElement.innerHTML = `
        .gm-svpc {
          left: -45px !important;
          width: 50px !important;
          height: 50px !important;
          border-radius: 50% !important;
          background-color: #1D1D1D !important;
          top: ${topValue} !important;
        }
      `;
  }

  componentDidUpdate(prevProps) {
    const { userPreferences } = this.props;
    let refContainer = this.mapContainer.current
    // Only perform actions if the units have changed
    if (prevProps.userPreferences.units !== userPreferences.units && refContainer) {
      this.handleUnitPreferenceChange();

    }
    if (prevProps.selectedTab !== this.props.selectedTab) {
      const topValue = this.props.selectedTab == "map" ? '-70px' : "0"
      let styleElement = document.getElementById('gm-style');
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = 'gm-style';
        document.head.appendChild(styleElement);
      }

      if (this.props.selectedTab != 'map') {
        // this.onChange3d()
        // Keep redux is3dMapselected in sync with the local openThreeD state — forcing
        // openThreeD off here without clearing is3dMapselected leaves it stale-true, so
        // 2D paths (My Content centering, marker/photo edit panels) wrongly take the 3D
        // branch when the user returns (WEB-7012).
        if (this.state.openThreeD) {
          this.props.unselected3dMapAction()
        }
        this.setState({ openThreeD: false, load3dMap: false })

      }

      // Set the CSS rules dynamically
      styleElement.innerHTML = `
          .gm-svpc {
            left: -45px !important;
            width: 50px !important;
            height: 50px !important;
            border-radius: 50% !important;
            background-color: #1D1D1D !important;
            top: ${topValue} !important;
          }
        `;
    }
  }

  handleUnitPreferenceChange() {
    const { userPreferences } = this.props;
    let refContainer = this.mapContainer.current
    if (refContainer) {

      const spans = refContainer.getElementsByTagName('span'),
        ptrnI = /\d+\s+(m|km)/i,
        ptrnM = /\d+\s+(ft|mi)/i;

      // Iterate over the spans and trigger clicks based on userPreferences.units
      for (let i = 0; i < spans.length; i++) {
        // If metric units are selected, trigger click for metric values
        if (userPreferences.units === 'metric' && ptrnM.test(spans[i].innerHTML)) {
          spans[i].click();
        }

        // If imperial units are selected, trigger click for imperial values
        if (userPreferences.units === 'imperial' && ptrnI.test(spans[i].innerHTML)) {
          spans[i].click();
        }
      }
    }
  }

  setFeatureData(featureData) {
    this.setState({ featureData })
  }

  clearFeatureData() {
    this.setState({ featureData: null })
  }

  mapReference() {
    return this.state.map
  }

  onChange3d = (haspro, type) => {
    if (haspro) {
      if (type === '3d' && !this.state.openThreeD) {
        // Only switch to 3D if not already in 3D
        this.setState(
          { openThreeD: true, load3dMap: true },
          () => {
            console.log('3D Opened');
            this.props.selected3dMapAction();
          }
        );
      } else if (type === '2d' && this.state.openThreeD) {
        // Only switch to 2D if currently in 3D
        this.setState(
          { openThreeD: false, load3dMap: false },
          () => {
            console.log('2D Opened');
            this.props.unselected3dMapAction();
          }
        );
      }
    } else {
      if (type === '3d') {
        showHideSubscriptionModal(this.props.token);
      }
    }
  };

  render() {
    const { leftToolbarState, rightToolbarState, userPreferences } = this.props,
      { loadspinner } = this.state,
      mapWidth = this.props.width ? this.props.width : 'calc(100vw - 78px)',
      mapOffset = this.props.left ? this.props.left : '78px',
      mapHeight = this.props.height ? this.props.height : 'calc(100vh - 62px)',
      mapTopset = this.props.top ? this.props.top : '60px',

      refContainer = this.refs.mapContainer

    let hasPro = userHasPro(this.props.user);

    return (
      <>
        <div className="map-container" style={{ height: '100vh' }}>
          {/* 3D map rendering when enabled */}
          {
            this.state.openThreeD && hasPro
            && (
              <>
                < Google3DMap
                  openThreeD={this.state.openThreeD}
                  markers={this.props.markers}
                  photos={this.props.photos}
                  polygons={this.props.polygons}
                  mapReference={this.mapContainer.current}
                  onMapLoaded={() => {
                    console.log("3D map loaded.");
                  }}
                  load3dMap={() => this.setState({ load3dMap: false })}
                />

              </>
            )

          }

          {/* 2D Map Container */}
          <div
            id="map"
            // ref="mapContainer"
            ref={this.mapContainer}
            style={{
              left: mapOffset,
              width: mapWidth,
              height: mapHeight,
              top: mapTopset,
              display: 'block'
            }}
          />

          {/* Render other features */}
          <ShareMarker />
          <Weather />
          <Geolocation />
          <LayerToggle />
          <RenderLayers />
          <div className="map-bottom-stack">
            <ImageryYear />
            <TimeLayerBar />
          </div>
          <RenderMarkers />
          <RenderPhotos />
          <RenderLines />
          <RenderTracks />
          <RenderRoutes />
          <RenderPolygons />
          <RenderCircles />
          <RenderGearDropMarkers />
          <CheckWind kind='2d' />
          <RenderFriends
            clearFeatureData={this.clearFeatureData.bind(this)}
            setFeatureData={this.setFeatureData.bind(this)}
          />

          {this.state.featureData && (
            <MapPopup
              clearFeatureData={this.clearFeatureData.bind(this)}
              featureData={this.state.featureData}
            />
          )}

          {loadspinner && (
            <div className="loader-spinner-my-content" style={{ left: '50%' }} />
          )}

          {/* 3D / 2D toggle from parent */}
          <div className='layer-toggle-container-child' style={{ left: 'calc( 40% + 250px )' }}>
            <div className='container-threed-twod'>

              <div className='layer-toggle' style={{
                backgroundColor: !this.state.openThreeD ? '#589500' : '',
                color: !this.state.openThreeD ? '#FFFFFF' : ''
              }}
                onClick={() => {
                  this.onChange3d(hasPro, '2d')
                }
                }
              >
                <p className='center'>2D</p>
              </div>

              <div className='layer-toggle' style={{
                backgroundColor: this.state.openThreeD ? '#589500' : '',
                color: this.state.openThreeD ? '#FFFFFF' : ''
              }}
                onClick={() => {
                  this.onChange3d(hasPro, '3d')
                }
                }
              >
                <p className='center'>3D</p>
              </div>

            </div>
          </div>
          {this.state.load3dMap && <Loader position={'absolute'} left={'50%'} width={'30px'} dark={true}></Loader>}
        </div>
      </>
    );

  }
}

const mapStateToProps = state => ({
  featureFields: state.featureFields,
  token: state.auth.token,
  loading: state.loading,
  leftToolbarState: state.leftToolbarState,
  rightToolbarState: state.rightToolbarState,
  layersDictionary: state.layersDictionary,
  userPreferences: state.userPreferences,
  featuresBlocked: state.featuresBlocked,
  mapReference: state.mapReference(),
  selectedTab: state.selectedTab,
  user: state.user,
  showThreedWelcomePopUp: state.showThreedWelcomePopUp
})

const mapDispatchToProps = dispatch => ({
  fetchFeatureInfoFields: id => dispatch(fetchFeatureInfoFields(id)),
  setMapReference: map => dispatch(setMapReference(map)),
  selectedTabAction: (payload) => dispatch(selectedTabAction(payload)),
  selected3dMapAction: () => dispatch(selected3dMapAction()),
  unselected3dMapAction: () => dispatch(unselected3dMapAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(Map)
